import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { green, red } from "@material-ui/core/colors";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import NewRfi from "./NewRfi";
import RfiList from "./RfiList";
import Button from "@material-ui/core/Button";
import { BrokerDataAPI } from '../../API/BrokerDataAPI';

export default function Rfis(props) {
	const { app, rfiList, loadRfis } = props;
	const useStyles = makeStyles((theme) => ({
		root: {
			backgroundColor: theme.palette.background.paper,
			width: 500,
			position: "relative",
			minHeight: 200,
		},
		fab: {
			position: "fixed",
			bottom: theme.spacing(8),
			right: theme.spacing(8),
			color: theme.palette.common.white,
			backgroundColor: green[500],
			"&:hover": {
				backgroundColor: green[600],
			},
		},
		fabClear: {
			position: "fixed",
			bottom: theme.spacing(8),
			right: theme.spacing(8),
			color: theme.palette.common.white,
			backgroundColor: red[500],
			"&:hover": {
				backgroundColor: red[600],
			},
		},
	}));

	const [loading, setLoading] = useState(true);
	const [refreshing, setRefreshing] = useState(false);
	const [showAddNew, setShowAddNew] = useState(false);
	const [showList, setShowList] = useState(true);
	const [broker, setBroker] = useState({});
	const classes = useStyles();

	useEffect(() => {
		(async () => {
			if (app) {
				try {
					await loadBroker();
				} catch (e) {
					console.log(e);
				} finally {
					setLoading(false);
				}
			}
		})();
	}, [app]);

	const loadBroker = async () => {
		let broker = await BrokerDataAPI.getBrokerById(app.broker_id, "ALL");
		setBroker(broker);
	};

	const toggleView = () => {
		setShowAddNew(!showAddNew);
		setShowList(!showList);
	};

	const onRfiSaved = async () => {
		try {
			toggleView();
			setRefreshing(true);
			await loadRfis();
		} catch (e) {
			console.log(e);
		} finally {
			setRefreshing(false);
		}
	};

	const onRfiResolved = async (rfi) => {
		try {
			setRefreshing(true);
			await loadRfis();
		} catch (e) {
			console.log(e);
		} finally {
			setRefreshing(false);
		}
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={2}>
				&nbsp;
			</Grid>
			<Grid item xs={8}>
				{loading ? (
					<Grid style={{ textAlign: "center", margin: "1rem" }}>
						<CircularProgress />
					</Grid>
				) : (
					<Grid container spacing={1}>
						{showAddNew ? (
							<Grid container spacing={1}>
								<Grid item xs={12} style={{ marginTop: 14 }}>
									<Typography variant="h6">New RFI</Typography>
								</Grid>
								<Grid item xs={12}>
									<NewRfi app={app} broker={broker} onRfiSaved={onRfiSaved} />
								</Grid>
							</Grid>
						) : (
							""
						)}
						{showList ? (
							<Grid container spacing={1}>
								<Grid item xs={12} style={{ marginTop: 14 }}>
									<Typography variant="h6" style={{ float: "left" }}>
										RFI List
									</Typography>
									<Typography variant="h6" style={{ float: "right" }}>
										<Button
											style={{
												backgroundColor: "#4caf50",
												color: "white",
											}}
											variant="contained"
											onClick={(e) => toggleView()}>
											New RFI
										</Button>
									</Typography>

									{refreshing ? (
										<span style={{ float: "right" }}>
											<CircularProgress
												size={20}
												color="secondary"
												style={{ marginRight: 5 }}
											/>
											<strong>Refreshing list...</strong>
										</span>
									) : (
										""
									)}
								</Grid>
								<Grid item xs={12}>
									<RfiList app={app} rfiList={rfiList} onRfiSaved={onRfiResolved} />
								</Grid>
							</Grid>
						) : (
							""
						)}
					</Grid>
				)}
			</Grid>
			<Grid item xs={2}>
				{loading ? (
					""
				) : showAddNew ? (
					<Fab
						color="inherit"
						className={classes.fabClear}
						size="small"
						aria-label="add"
						onClick={(e) => toggleView()}>
						<CloseIcon />
					</Fab>
				) : null}
			</Grid>
		</Grid>
	);
}
